import { createSelector } from 'reselect'

import { selectCommitmentState } from './selectCommitmentState'

export const selectCommitmentStatuses = createSelector(
  [selectCommitmentState],
  (state) => state.commitmentStatuses.data
)
